import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "customer" }
const _hoisted_2 = { class: "user-header" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-8 col-form-label" }, "Feedback link active", -1)
const _hoisted_7 = { class: "col-sm-1" }
const _hoisted_8 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-8 col-form-label" }, "Feedback link active for (Days)", -1)
const _hoisted_10 = { class: "col-sm-3" }
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-8 col-form-label" }, "Hide ACT address from report", -1)
const _hoisted_13 = { class: "col-sm-1" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-8 col-form-label" }, "Redline CheckOut", -1)
const _hoisted_16 = { class: "col-sm-4" }
const _hoisted_17 = { class: "form-group row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-8 col-form-label" }, "CheckOut Summary", -1)
const _hoisted_19 = { class: "col-sm-1" }
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-8 col-form-label" }, "Redline CheckOut Summary", -1)
const _hoisted_22 = { class: "col-sm-1" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-8 col-form-label" }, "Mid Term report active", -1)
const _hoisted_26 = { class: "col-sm-1" }
const _hoisted_27 = { class: "col-sm-8 col-form-label" }
const _hoisted_28 = { class: "col-sm-1" }

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { Customer, Dictionary, DictionaryReportType } from "@/models";
import { DxSwitch } from 'devextreme-vue/switch';

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportSettings',
  setup(__props) {

const listofdays = ref([
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23, 24, 25, 26, 27, 28, 29, 30,
]);
const dictionary = computed(() => store.getters['dictionary/current']);

const store = useStore();
const customer = computed(() => store.getters['customers/current']);
const editCustomer = async (customer: Customer) => await store.dispatch('customers/editCustomer', customer);
const setCustomerDeep = async (payload: {
  path: string;
  data: any;
}) => {
  await store.dispatch('customers/setCustomerDeep', payload);
}
const editCurrentCustomer = () => {
  editCustomer(customer.value);
};
const getReporttypesWithDictionary = computed(() => {
  return dictionary.value?.reporttypes?.filter((t) => t.dictionaryflag === true);
});


const isReporttypeactive = (reporttype: DictionaryReportType) => {
  const type = customer.value.reportsettings.activereporttypes.find(
    (r) => r === reporttype.slug
  );
  return type ? true : false;
};
const toggleReporttypeactive = (reporttype: DictionaryReportType) => {
  const index = customer.value.reportsettings.activereporttypes.indexOf(
    reporttype.slug
  );

  if (index >= 0) {
    customer.value.reportsettings.activereporttypes.splice(index, 1);
  } else {
    customer.value.reportsettings.activereporttypes.push(reporttype.slug);
  }

  // Emit an event to notify the parent component about the change
  editCurrentCustomer();
}

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(DxSwitch), {
                    value: customer.value.feedbacklinkactive,
                    onValueChanged: _cache[0] || (_cache[0] = ($event: any) => (setCustomerDeep({ path: 'feedbacklinkactive', data: $event.value })))
                  }, null, 8, ["value"])
                ])
              ]),
              (customer.value.feedbacklinkactive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_singleselect_text, {
                        modelValue: customer.value.feedbacklinkactivedays,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customer.value.feedbacklinkactivedays) = $event)),
                        value: customer.value.feedbacklinkactivedays,
                        options: listofdays.value,
                        onSelect: _cache[2] || (_cache[2] = ($event: any) => (editCurrentCustomer()))
                      }, null, 8, ["modelValue", "value", "options"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(DxSwitch), {
                    value: customer.value.hidefrontpageaddress,
                    onValueChanged: _cache[3] || (_cache[3] = ($event: any) => (setCustomerDeep({ path: 'hidefrontpageaddress', data: $event.value })))
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(DxSwitch), {
                    value: customer.value.reportsettings.redlinecoactive,
                    onValueChanged: _cache[4] || (_cache[4] = ($event: any) => (setCustomerDeep({ path: 'reportsettings.redlinecoactive', data: $event.value })))
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_unref(DxSwitch), {
                    value: customer.value.reportsettings.cosummaryactive,
                    onValueChanged: _cache[5] || (_cache[5] = ($event: any) => (setCustomerDeep({ path: 'reportsettings.cosummaryactive', data: $event.value })))
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(DxSwitch), {
                    value: customer.value.reportsettings.cosmredlineactive,
                    onValueChanged: _cache[6] || (_cache[6] = ($event: any) => (setCustomerDeep({ path: 'reportsettings.cosmredlineactive', data: $event.value })))
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_unref(DxSwitch), {
                    value: customer.value.midtermactive,
                    onValueChanged: _cache[7] || (_cache[7] = ($event: any) => (setCustomerDeep({ path: 'midtermactive', data: $event.value })))
                  }, null, 8, ["value"])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getReporttypesWithDictionary.value, (reporttype) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-group row",
                  key: reporttype.slug
                }, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(reporttype.displayname) + " active", 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_unref(DxSwitch), {
                      value: isReporttypeactive(reporttype),
                      onValueChanged: ($event: any) => (toggleReporttypeactive(reporttype))
                    }, null, 8, ["value", "onValueChanged"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})